module.exports = __webpack_public_path__ + "static/media/twB2.52850563.png";